var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.18,
    height: 38.228,
    viewBox: "0 0 57.18 38.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4689",
    "data-name": "Path 4689",
    d: "M33.411-66.034a21.149,21.149,0,0,0-9.534,5.618Q20.132-56.5,20.132-49.35q.851-.17,1.362-.255a8.65,8.65,0,0,1,1.362-.085q4.426.17,6.469,2.724a9.506,9.506,0,0,1,2.043,6.129,6.516,6.516,0,0,1-2.554,5.618,9.541,9.541,0,0,1-5.788,1.873q-5.958,0-8.512-3.575a14.84,14.84,0,0,1-2.554-8.853,23.773,23.773,0,0,1,1.788-9.448,23.6,23.6,0,0,1,4.767-7.235,26.881,26.881,0,0,1,6.895-5.107,30.856,30.856,0,0,1,8-2.894Zm34.729,0a21.149,21.149,0,0,0-9.534,5.618Q54.861-56.5,54.861-49.35q.851-.17,1.362-.255a8.65,8.65,0,0,1,1.362-.085q4.426.17,6.469,2.724A9.506,9.506,0,0,1,66.1-40.838a6.516,6.516,0,0,1-2.554,5.618,9.541,9.541,0,0,1-5.788,1.873q-5.958,0-8.512-3.575a14.84,14.84,0,0,1-2.554-8.853,23.773,23.773,0,0,1,1.788-9.448,23.6,23.6,0,0,1,4.767-7.235,26.881,26.881,0,0,1,6.895-5.107,30.856,30.856,0,0,1,8-2.894Z",
    transform: "translate(-11.46 71.075)",
    fill: "#191919",
    stroke: "#191919",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/Quote.8f29ed85eab3da98d975578bb699bd9a.svg";
export { ForwardRef as ReactComponent };